import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import API from "../../api"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider, {Search} from "react-bootstrap-table2-toolkit"
import {
    Row,
    Col,
    Spinner,
    Modal,
    ModalHeader,
    ModalBody,
    Button, CardTitle, Form, Label,
} from "reactstrap"
import {withRouter} from "react-router"
import {Slide, toast, ToastContainer} from "react-toastify";
import Select from "react-select";
import FileDownload from "js-file-download";

const DataTableCalendrierSurveillance = props => {
    const [loading, setLoading] = useState(false)
    const [modal, setModal] = useState(false)
    const [modalDetail, setModalDetail] = useState(false);
    const [id, setId] = useState("")
    const [orders, setOrders] = useState([])
    const [add, setAdd] = useState(0);
    const [edit, setEdit] = useState(0);
    const [delet, setDelet] = useState(0);
    const [cloture, setCloture] = useState(0);
    const [selectSemestre, setSelectSemestre] = useState("")
    const [niveau, setNiveau] = useState([])
    const [selectNiveau, setSelectNiveau] = useState("")
    const [specialite, setSpecialite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    const [modalDeleteGroup, setModalDeleteGroup] = useState(false);
    const [enseignant, setEnseignant] = useState([]);
    const [selectEnseignant, setSelectEnseignant] = useState("");
    const [enseignantSecondaire, setEnseignantSecondaire] = useState([]);
    const [selectEnseignantSecondaire, setSelectEnseignantSecondaire] = useState("")
    const [view, setView] = useState(0);
    const [arrayPrincipale, setArrayPrincipale] = useState([]);
    const [arraySecondaire, setArraySecondaire] = useState([]);
    const [modalEdit, setModalEdit] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [excel, setExcel] = useState(0);
    const pageOptions = {
        loading: true,
        hidePageListOnlyOnePage: true,
        totalSize: orders.length,
        page: 1,
        nextPageText: "Suivant",
        prePageText: "Précédent",
        alwaysShowAllBtns: true,
        sizePerPageList: [
            {
                text: "50",
                value: 50,
            },
            {
                text: "100",
                value: 10,
            },
            {
                text: "150",
                value: 150,
            },
            {
                text: "All",
                value: orders.length,
            },
        ],
    }
    var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
    var annee_id = userAuthScolarite.user.annee_id
    var user_id = userAuthScolarite.user.id
    const NoDataIndication = () => (
        <h6 style={{textAlign: "center"}}>No record to display</h6>
    )
    const Columns = () => [
        {
            dataField: "date",
            text: "Date ",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "Jour",
            text: "Jours",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "heure_debut",
            text: "Heure",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "groupe",
            text: "Nom du groupe",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },

        {
            dataField: "matiere",
            text: "Matière",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "salle",
            text: "Salle",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "enseignant_responsable",
            text: "Enseignant responsable",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "Add",
            isDummyField: true,
            text: "Ajouter enseignant",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) => (
                cloture !== 1 ? (
                        add === 1 ? (
                            row.etat_surveillance === 0 ? (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#0694ff", cursor: "pointer"}}
                                        onClick={() => toggle(row.id_first_seance_examen)}
                                        className="fas fa-plus"
                                        title={"Ajouter un enseignant pour la surveillance"}
                                    ></i>
                                </div>
                            ) : (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#a7a3a3", cursor: "pointer"}}
                                        className="fas fa-plus"
                                        title={"Cette séance d'examen a déjà un calendrier de surveillance"}
                                    ></i>
                                </div>
                            )
                        ) : (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#a7a3a3", cursor: "pointer"}}
                                    className="fas fa-plus"
                                    title="Vous n'avez pas d'accès"
                                ></i>
                            </div>
                        )
                    ) :
                    (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#a7a3a3", cursor: "pointer"}}
                                className="fas fa-plus"
                                title="Année clôturée"
                            ></i>
                        </div>
                    )
            ),
        },
        {
            dataField: "Detail",
            isDummyField: true,
            text: "Détail surveillance",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) => (
                cloture !== 1 ? (
                        view === 1 ? (
                            row.etat_surveillance === 1 ? (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#1a9e3a", cursor: "pointer"}}
                                        onClick={() => toggleDetail(row.id_first_seance_examen)}
                                        className="fas fa-eye"
                                        title={"Détail surveillance"}
                                    ></i>
                                </div>
                            ) : (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#a7a3a3", cursor: "pointer"}}
                                        className="fas fa-eye"
                                        title={"Cette séance d'examen n'a pas un calendrier de surveillance"}
                                    ></i>
                                </div>
                            )
                        ) : (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#a7a3a3", cursor: "pointer"}}
                                    className="fas fa-eye"
                                    title="Vous n'avez pas d'accès"
                                ></i>
                            </div>
                        )
                    ) :
                    (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#a7a3a3", cursor: "pointer"}}
                                className="fas fa-eye"
                                title="Année clôturée"
                            ></i>
                        </div>
                    )
            ),
        },
        {
            dataField: "enseignants",
            text: "Enseignants",
            sort: true,
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
        },
        {
            dataField: "Modification rapide",
            isDummyField: true,
            text: "Modification rapide",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) => (
                cloture !== 1 ? (
                        edit === 1 ? (
                            row.etat_surveillance === 1 ? (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#e4ac67", cursor: "pointer"}}
                                        onClick={() => toggleEdit(row.id_first_seance_examen)}
                                        className="fas fa-edit"
                                        title={"Modification rapide du surveillance"}
                                    ></i>
                                </div>
                            ) : (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#a7a3a3", cursor: "pointer"}}
                                        className="fas fa-edit"
                                        title={"Modification rapide d'un calendrier de surveillance"}
                                    ></i>
                                </div>
                            )
                        ) : (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#a7a3a3", cursor: "pointer"}}
                                    className="fas fa-edit"
                                    title="Vous n'avez pas d'accès"
                                ></i>
                            </div>
                        )
                    ) :
                    (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#a7a3a3", cursor: "pointer"}}
                                className="fas fa-eye"
                                title="Année clôturée"
                            ></i>
                        </div>
                    )
            ),
        },
        {
            dataField: "Suppression",
            isDummyField: true,
            text: "Suppression",
            style: {textAlign: "center"},
            headerStyle: (colum, colIndex) => {
                return {textAlign: "center"}
            },
            sort: true,
            // eslint-disable-next-line react/display-name
            formatter: (cellContent, row) => (
                cloture !== 1 ? (
                        delet === 1 ? (
                            row.etat_surveillance === 1 ? (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#ea0b0b", cursor: "pointer"}}
                                        onClick={() => toggleDeleteGroup(row.id_first_seance_examen)}
                                        className="fas fa-trash"
                                        title={"Suppression du surveillance"}
                                    ></i>
                                </div>
                            ) : (
                                <div style={{display: "flex", justifyContent: "center"}}>
                                    <i
                                        style={{color: "#a7a3a3", cursor: "pointer"}}
                                        className="fas fa-trash"
                                        title={"Suppression rapide d'un calendrier de surveillance"}
                                    ></i>
                                </div>
                            )
                        ) : (
                            <div style={{display: "flex", justifyContent: "center"}}>
                                <i
                                    style={{color: "#a7a3a3", cursor: "pointer"}}
                                    className="fas fa-trash"
                                    title="Vous n'avez pas d'accès"
                                ></i>
                            </div>
                        )
                    ) :
                    (
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <i
                                style={{color: "#a7a3a3", cursor: "pointer"}}
                                className="fas fa-eye"
                                title="Année clôturée"
                            ></i>
                        </div>
                    )
            ),
        },
    ]

    const {SearchBar} = Search

    useEffect(async () => {
        var cloture_annee = JSON.parse(localStorage.getItem("cloture"));
        setCloture(cloture_annee)
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Calendrier de surveillance")
        );
        setAdd(typeArticleSubMenu.sous_menu[0].add)
        setEdit(typeArticleSubMenu.sous_menu[0].edit)
        setDelet(typeArticleSubMenu.sous_menu[0].delete)
        setExcel(typeArticleSubMenu.sous_menu[0].exel)
        setView(typeArticleSubMenu.sous_menu[0].view)
        const res = await API.post("seance_examen/index_etat_surv", {
            annee_id,
            semestre_id: props.semestre.value
        }).then(res => {
            setOrders(res.data.list)
        })
        const resNiveau = await API.get("niveau/select").then(resNiveau => {
            setNiveau(resNiveau.data.Niveau)
        })
        setLoading(true)
    }, [props.semestre])

    const toggle = id => {
        setModal(!modal)
        setId(id)
        if (modal !== true) {
            API.post("surveillance_examen/get_enseignants_libre", {
                id: id,
                annee_id,
                semestre_id: props.semestre.value,
            }).then(res => {
                setEnseignant(res.data.enseignants_libres)
                setEnseignantSecondaire(res.data.enseignants_libres)
            })
        }
    }
    const toggleDeleteLibre = id => {
        setModalDelete(!modalDelete)
        setId(id)
    }
    const toggleEdit = id => {
        setModalEdit(!modalEdit)
        setId(id)
        if (modalEdit !== true) {
            API.post("surveillance_examen/get_enseignants_libre", {
                id: id,
                annee_id,
                semestre_id: props.semestre.value,
            }).then(res => {
                setEnseignant(res.data.enseignants_libres)
                setEnseignantSecondaire(res.data.enseignants_libres)
            })
            API.post("surveillance_examen/consult_seance_value_label", {
                seance_id: id,
                annee_id,
            }).then(res => {
                setSelectEnseignant(res.data.surveillance.principales)
                setSelectEnseignantSecondaire(res.data.surveillance.secondaires)
            })
        }


    }
    const toggleDetail = id => {
        setModalDetail(!modalDetail)
        setId(id)
        if (modalDetail !== true) {
            API.post("surveillance_examen/consult_seance", {
                seance_id: id,
                annee_id,
            }).then(res => {
                setArrayPrincipale(res.data.surveillance.principales)
                setArraySecondaire(res.data.surveillance.secondaires)
            })
        }
    }
    const toggleDeleteGroup = id => {
        setModalDeleteGroup(!modalDeleteGroup)
        setId(id)
    }

    const toggleDelete = async () => {
        var selectEnseignant2 = selectEnseignantSecondaire === "" ? [] : selectEnseignantSecondaire;

        const res = await API.post("surveillance_examen/affecter", {
            seance_id: id,
            semestre_id: props.semestre.value,
            annee_id,
            enseignants_pricipales: selectEnseignant,
            enseignants_secondaires: selectEnseignant2,
            user_id
        }).then(res => {
            if (res.data.errNum === "301" || res.data.errNum === 301) {
                toast.error("⛔ " + res.data.msg, {
                    containerId: "A",
                })
            } else {
                API.post("seance_examen/index_etat_surv", {annee_id, semestre_id: props.semestre.value}).then(res => {
                    setOrders(res.data.list)
                })
                setModal(false)
                setLoading(true)
            }

        })
    }
    const toggleEditSeance = async () => {

        const res = await API.post("surveillance_examen/update", {
            seance_id: id,
            semestre_id: props.semestre.value,
            annee_id,
            enseignants_pricipales: selectEnseignant,
            enseignants_secondaires: selectEnseignantSecondaire,
            user_id
        }).then(res => {
            if (res.data.errNum === "301" || res.data.errNum === 301) {
                toast.error("⛔ " + res.data.msg, {
                    containerId: "A",
                })
            } else {
                API.post("seance_examen/index_etat_surv", {annee_id, semestre_id: props.semestre.value}).then(res => {
                    setOrders(res.data.list)
                })
                setLoading(true)
                setModalEdit(false)
            }

        })
    }
    const toggleDeleteGroupExamen = async () => {
        setModalDeleteGroup(false)
        const res = await API.post("surveillance_examen/delete_by_seance", {
            user_id,
            annee_id,
            id_seance:id
        }).then(res => {
            const resD = API.post("seance_examen/index_etat_surv", {annee_id,semestre_id: props.semestre.value}).then(resD => {
                setOrders(resD.data.list)
            })
            setLoading(true)
        })
    }

    useEffect(() => {
        setModal(false)
    }, [orders])
    const getSpecialite = async event => {
        setSelectNiveau(event)
        const res = await API.post("group/get_list_spec", {
            niveau_id: event.value,
            semestre_id: [props.semestre],
        }).then(res => {
            setSpecialite(res.data.Groups)
        })
    }
    const search = async () => {

        const specialite_id = selectSpecialite != "" && selectSpecialite != null ? selectSpecialite.value : 0;
        const niveau_id = selectNiveau != "" && selectNiveau != null ? selectNiveau.value : 0;
        setOrders([])
        const res = await API.post("seance_examen/search_etat_surv", {
            specialite_id: specialite_id,
            niveau_id: niveau_id,
            semestre_id: props.semestre.value,
            annee_id
        }).then(res => {
            setOrders(res.data.list)
        })

    }
    const searchAll = async () => {
        setSelectNiveau("")
        setSelectSpecialite("")
        setSelectSemestre("")
        const resD = API.post("seance_examen/index_etat_surv", {
            annee_id,
            semestre_id: props.semestre.value
        }).then(resD => {
            setOrders(resD.data.list)
        })
        setLoading(true)
    }
    const excelExport = async () => {
        const res = await API.post('surveillance_examen/export',
            {
                semestre_id: props.semestre.value,
                annee_id
            },
            {responseType: "blob"}
        ).then(res => {
            FileDownload(res.data, "Surveillance.xlsx")
        })
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Col xs="12">
                            <ToolkitProvider
                                keyField="id"
                                data={orders}
                                columns={Columns()}
                                search
                                bootstrap4
                            >
                                {toolkitProps => (
                                    <div>
                                        <CardTitle style={{color: "#556ee6"}} className="h4">
                                            Critéres de Recherches
                                        </CardTitle>
                                        <Form className="mt-4">
                                            <Row>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Niveau</Label>
                                                        <Select
                                                            options={niveau}
                                                            isSearchable={true}
                                                            value={selectNiveau}
                                                            isClearable={true}
                                                            onChange={e => getSpecialite(e)}
                                                        />
                                                    </div>
                                                </Col>
                                                <Col lg="6">
                                                    <div className="mb-3">
                                                        <Label for="basicpill-firstname-input1">Spécialité</Label>
                                                        <Select
                                                            options={specialite}
                                                            value={selectSpecialite}
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            onChange={e => setSelectSpecialite(e)}
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Form>
                                        <div style={{display: "flex", justifyContent: "center"}}>

                                            <Col lg="12">
                                                <div className="text-center mt-4">
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={search}
                                                    >
                                                        Rechercher
                                                    </button>
                                                    <button
                                                        type="button"
                                                        style={{
                                                            backgroundColor: "#761C19",
                                                            borderColor: "#761C19",
                                                        }}
                                                        className="btn btn-success mb-2 me-2"
                                                        onClick={searchAll}
                                                    >
                                                        Afficher tout
                                                    </button>
                                                    {cloture !== 1 ? (
                                                        excel === 1 ? (
                                                            <a className="col-md-3"
                                                               onClick={excelExport}
                                                               rel="noreferrer"
                                                            >
                                                                <button style={{
                                                                    backgroundColor: "#67088d",
                                                                    borderColor: "#67088d",
                                                                }}
                                                                        className="btn btn-primary btn btn-primary mb-2 me-2">
                                                                    <i className="fas fa-file-pdf font-size-18 align-middle me-2"></i>
                                                                    Exporter les surveillances
                                                                </button>
                                                            </a>
                                                        ) : null
                                                    ) : null}
                                                </div>
                                            </Col>

                                        </div>
                                        <Col sm="4">
                                            <div className="search-box me-2 mb-2 d-inline-block">
                                                <div className="position-relative">
                                                    <SearchBar {...toolkitProps.searchProps} />
                                                    <i className="bx bx-search-alt search-icon"/>
                                                </div>
                                            </div>
                                        </Col>
                                        <BootstrapTable
                                            wrapperClasses="table-responsive"
                                            noDataIndication={() => <NoDataIndication/>}
                                            striped={false}
                                            bordered={false}
                                            classes={"table align-middle table-nowrap"}
                                            headerWrapperClasses={"table-light"}
                                            hover
                                            pagination={paginationFactory(pageOptions)}
                                            {...toolkitProps.baseProps}
                                        />
                                    </div>
                                )}
                            </ToolkitProvider>
                        </Col>
                    </Row>
                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            En cours ...{" "}
                        </h4>
                    </div>
                )}
            </div>
            <Modal isOpen={modal} toggle={toggle} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggle}
                    tag="h4">
                    {"Ajouter l'enseignant principal et secondaire pour la surveillance d'examen"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >

                        <Row>
                            <Col md={12}>
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">Enseignant 1:</Label>
                                    <Select
                                        options={enseignant}
                                        isSearchable={true}
                                        onChange={e => setSelectEnseignant(e)}
                                        isMulti={true}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">Enseignant 2:</Label>
                                    <Select
                                        options={enseignantSecondaire}
                                        isSearchable={true}
                                        onChange={e => setSelectEnseignantSecondaire(e)}
                                        isMulti={true}
                                    />
                                </div>
                            </Col>
                        </Row>


                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleDelete}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Confirmer
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggle}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalEdit} toggle={toggleEdit} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggleEdit}
                    tag="h4">
                    {"Modification rapide de l'enseignant principal et secondaire pour la surveillance d'examen"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >

                        <Row>
                            <Col md={12}>
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">Enseignant principal:</Label>
                                    <Select
                                        options={enseignant}
                                        isSearchable={true}
                                        onChange={e => setSelectEnseignant(e)}
                                        isMulti={true}
                                        value={selectEnseignant}
                                    />
                                </div>
                            </Col>
                            <Col md={12}>
                                <div className="mb-3">
                                    <Label for="basicpill-firstname-input1">Enseignant secondaire:</Label>
                                    <Select
                                        options={enseignantSecondaire}
                                        isSearchable={true}
                                        onChange={e => setSelectEnseignantSecondaire(e)}
                                        isMulti={true}
                                        value={selectEnseignantSecondaire}
                                    />
                                </div>
                            </Col>
                        </Row>


                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleEditSeance}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Confirmer
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggleEdit}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalDetail} toggle={toggleDetail} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggleDetail}
                    tag="h4">
                    {"Détail de surveillance pour cette séance d'examen"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >

                        <Row>
                            <CardTitle style={{color: "#556ee6"}} className="h4">
                                Enseignant principale
                            </CardTitle>
                            <table className="table table-bordered text-center">
                                <thead>
                                <th>Nom enseignant</th>
                                </thead>
                                <tbody>
                                {arrayPrincipale.map((el, index) => (
                                    <tr key={index}>
                                        <td>{el.name}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            <CardTitle style={{color: "#556ee6"}} className="h4">
                                Enseignant secondaire
                            </CardTitle>
                            <table className="table table-bordered text-center">
                                <thead>
                                <th>Nom enseignant</th>
                                </thead>
                                <tbody>
                                {arraySecondaire.map((el, index) => (
                                    <tr key={index}>
                                        <td>{el.name}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>

                        </Row>


                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >

                            <div>
                                <Button
                                    onClick={toggleDetail}
                                    style={{color: "#556ee6"}}
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Annuler
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <Modal isOpen={modalDeleteGroup} toggle={toggleDeleteGroup} centered={true}>
                <ModalHeader
                    style={{width: "100% !important", textAlign: "center !important"}}
                    toggle={toggleDeleteGroup}
                    tag="h4"
                >
                    {"Suppression surveillance"}
                </ModalHeader>
                <ModalBody>
                    <div
                        style={{
                            fontFamily: "Montserrat, sans-serif",
                            FontSize: "14px",
                            FontWeight: "700",
                            LineHeight: "18.375px",
                        }}
                    >
                        <div style={{display: "flex", justifyContent: "center"}}>
                            <p>{"Voulez - vous supprimer cette surveillance ?"}</p>
                        </div>
                        <div
                            className="hvr-push"
                            style={{
                                display: "flex",
                                justifyContent: "space-around",
                                marginBottom: "15px",
                            }}
                        >
                            <div>
                                <Button
                                    color="info"
                                    className="btn-rounded "
                                    onClick={toggleDeleteGroupExamen}
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-up"
                                    ></i>
                                    Oui
                                </Button>
                            </div>
                            <div>
                                <Button
                                    onClick={toggleDeleteGroup}
                                    color="danger"
                                    className="btn-rounded "
                                >
                                    <i
                                        style={{color: "white"}}
                                        className="far fa-thumbs-down"
                                    ></i>
                                    Non
                                </Button>
                            </div>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}


export default withRouter(DataTableCalendrierSurveillance)
DataTableCalendrierSurveillance.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
    semestre: PropTypes.object,
}
